// extracted by mini-css-extract-plugin
export default {"Wrapper":"GridWrapper_Wrapper__Z6UW2","main":"GridWrapper_main__aTWPK","intro":"GridWrapper_intro__MNFt4","outro":"GridWrapper_outro__4TTJo"};